<template>
  <v-list-item
    class="white--text"
    exact-active-class="active-link"
    :to="link.route.path"
    exact
    link
    ripple
    :disabled="link.adminOnly && user.userType != 'ADMIN'"
  >
    <v-list-item-icon>
      <v-icon color="white" v-text="link.icon"></v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title v-text="link.title"></v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SNavbarLink",
  props: ["link"],
  computed: {
    ...mapGetters({
      user: "auth/getUser",
    }),
  },
};
</script>

<style scoped>
.active-link {
  color: #fff !important;
  font-weight: bold;
  border-right: 3px solid var(--v-darkColor-base) !important;
}
</style>
